module.exports = __webpack_public_path__ + "img/396-606495.png";